<div class="container">
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</div>
